export default "__VITE_ASSET__Ds9oQP7f__"